import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.proposal');
import { OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-proposal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.proposal/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageProposalComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public proposalUrl: SafeResourceUrl;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.proposalUrl = this.sanitizer.bypassSecurityTrustResourceUrl('/api/proposal/index.html');
        await this.service.render();
    }
}

export default PageProposalComponent;